// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1z5va","info":"Note_info__3JmEg","note":"Note_note__xRzNo","actions":"Note_actions__29jWc"};